import { useMutation } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { ApplicationListCreationValidationRequest } from 'src/types/rest/tenant';

export const useValidateCreateApplicationList = () => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: ApplicationListCreationValidationRequest) =>
      apiRequest<void>({
        data: variables,
        method: 'POST',
        url: `${apiHost}/application-lists/validation`,
      }),
  });
};
